import Vue from "vue";
import Vuex from "vuex";

import Login from "@/Login/store/Login.Store";
import Case from "@/Case/store/Case.Store";
import Cases from "@/Cases/store/Cases.Store";
import Trucks from "@/Trucks/store/Trucks.Store";
import Users from "@/Users/store/Users.Store";
import Error from "@/App/store/Error.Store";
import Global from "@/App/store/Global.Store";
import BroadcastMessages from "@/BroadcastMessages/store/BroadcastMessages.Store";
import Feedback from "@/App/components/feedback/store/feedback.store";
import { WeekSelectorStore } from "@/App/WeekSelector.store";

Vue.use(Vuex);

export const Store = new Vuex.Store({
  modules: {
    Global,
    Error,
    Login,
    Case,
    Cases,
    Trucks,
    Users,
    BroadcastMessages,
    Feedback,
    WeekSelectorStore
  }
});

export default Store;
